import store from '@/store';
import { isCorporateEnvironment } from '@/utils/corporate/environment';
import {
    companyPayloadFromWebsite,
    isCorporateTypeBusiness,
    resolveTypeBusinessFromState,
} from '@/utils/corporate/typeBusiness';

export const ADMIN_DASHBOARD_MODE = {
    ESCOLAR: 'escolar',
    CORPORATIVO: 'corporativo',
};

const SCHOOL_ONLY_PREFIXES = [
    '/dashboard/painel',
    '/dashboard/usuarios',
    '/dashboard/cupons',
    '/dashboard/form-usuario',
];

const CORPORATE_PREFIXES = [
    '/dashboard/corporativo',
];

/**
 * Modo do admin segue typeBusiness (2=corporativo, 1=escolar).
 * Sem seletor manual no header.
 */
export function getAdminDashboardMode() {
    return isCorporateEnvironment()
        ? ADMIN_DASHBOARD_MODE.CORPORATIVO
        : ADMIN_DASHBOARD_MODE.ESCOLAR;
}

export function isAdminCorporateMode() {
    return getAdminDashboardMode() === ADMIN_DASHBOARD_MODE.CORPORATIVO;
}

export function setAdminDashboardMode(mode) {
    store.dispatch('storeAdminDashboardMode', {
        adminDashboardMode: mode === ADMIN_DASHBOARD_MODE.CORPORATIVO
            ? ADMIN_DASHBOARD_MODE.CORPORATIVO
            : ADMIN_DASHBOARD_MODE.ESCOLAR,
    });
}

/**
 * Sincroniza company + adminDashboardMode a partir do website/login (typeBusiness).
 */
export function syncAdminModeFromTypeBusiness(website) {
    const fromWebsite = companyPayloadFromWebsite(website);
    if (fromWebsite) {
        store.dispatch('storeCompany', { company: fromWebsite });
    }

    const typeBusiness = resolveTypeBusinessFromState(store.state)
        ?? (fromWebsite ? (isCorporateTypeBusiness(fromWebsite.typeBusiness) ? 2 : 1) : null);

    if (typeBusiness === 2) {
        setAdminDashboardMode(ADMIN_DASHBOARD_MODE.CORPORATIVO);
        return ADMIN_DASHBOARD_MODE.CORPORATIVO;
    }
    if (typeBusiness === 1) {
        setAdminDashboardMode(ADMIN_DASHBOARD_MODE.ESCOLAR);
        return ADMIN_DASHBOARD_MODE.ESCOLAR;
    }
    return getAdminDashboardMode();
}

export function resolveModeHome(mode) {
    if (mode === ADMIN_DASHBOARD_MODE.CORPORATIVO) {
        return '/dashboard/corporativo/visao-geral';
    }
    return '/dashboard/painel';
}

export function pathBelongsToMode(path, mode) {
    const current = path || '';
    if (mode === ADMIN_DASHBOARD_MODE.CORPORATIVO) {
        if (SCHOOL_ONLY_PREFIXES.some((prefix) => current === prefix || current.startsWith(`${prefix}/`))) {
            return false;
        }
        return true;
    }
    if (CORPORATE_PREFIXES.some((prefix) => current === prefix || current.startsWith(`${prefix}/`))) {
        return false;
    }
    return true;
}
